import {
  ModulosMotivoENUM,
  formatDateWithTimeAMPM,
  gridSizeMdLg12,
  gridSizeMdLg4,
  texto,
} from "@/shared";
import {
  getBodegas,
  getUbicaciones,
  useFetchMotivos
} from "@/shared/actions/erp";
import { useFetchUnidadTransporte } from "@/shared/actions/erp/administration/unidad-transporte.actions";
import {
  CustomAutocomplete,
  CustomTextField,
  CustomTextFieldNoForm,
} from "@/shared/components/ui";
import {
  AlertSeverityEnum,
  IDtaUnidadTransporte,
  ISolicitudTrasladoForm,
} from "@/shared/interfaces";
import { BODEGAS, Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { IDataMotivo } from "@/shared/interfaces/erp/inventario/motivo.interface";
import { useUiStore } from "@/store/ui";
import { Grid } from "@mui/material";
import {
  Control,
  FieldError,
  FieldErrors,
  FieldPath,
  FieldValues,
  UseFormReset,
  UseFormReturn,
  get
} from "react-hook-form";
import { IDataTransferenciaInventario } from "./datos_transferencia_componente.interface";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import { toast } from "react-toastify";
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import { useMemo } from "react";


interface DatosTransferenciaComponenteProps<T extends FieldValues> {
  form: UseFormReturn<T, any, T>;
  errors: FieldErrors<T>;
  control: Control<T, any>;
  reset: UseFormReset<T>;
  //dataTransferenciaInventario?: IDataSolicitudTraslado;
  dataTransferenciaInventario?: IDataTransferenciaInventario;
  onChangeDeleteItem?: () => void;
  idsolicitudEgreso?: string;
  disabledForm?: boolean;
}

export default function DatosTransferenciaComponente<T extends FieldValues>({
  form,
  errors,
  control,
  reset,
  dataTransferenciaInventario,
  onChangeDeleteItem,
  idsolicitudEgreso,
  disabledForm = false
}: DatosTransferenciaComponenteProps<T>) {


  const bodega_origen = form.watch('bodega_origen' as FieldPath<T>);
  const bodega_destino = form.watch('bodega_destino' as FieldPath<T>);

  ///* store, hook
  const {
    fetchAutocompleteUbicacion,
    fetchAutocompleteBodega
  } = useAutocompleteFetch();

  const setAlert = useUiStore((s) => s.setAlert);

  ///* fetch
  const {
    data: dataMotivo,
    isLoading: isLoadingMotivo
  } = useFetchMotivos({
    page: 1,
    page_size: 100,
    modulo: ModulosMotivoENUM.TRASLADO_INVENTARIO,
  });
  const { data: dataUT, isLoading: isLoadingUT } = useFetchUnidadTransporte({
    page_size: 100,
  });


  ///* memo

  const bodegaDestinoParams = useMemo(() => ({
    es_destino: true,
  }), [])

  const ubicacionOrigenParams = useMemo(() => ({
    bodega: bodega_origen
  }), [bodega_origen])


  const ubicacionDestinoParams = useMemo(() => ({
    bodega: bodega_destino,
    es_destino: true
  }), [bodega_destino])

  const getFieldError = (
    field: FieldPath<T>
  ): FieldError | undefined => {
    return get(errors, field);
  };

  const errorUnidadTransporte = getFieldError(
    'unidad_transporte' as FieldPath<T>
  );

  const errorObservacion1 = getFieldError(
    'observacion_1' as FieldPath<T>
  );

  const errorSolicitadoPor = getFieldError(
    'solicitado_por' as FieldPath<T>
  );

  const errorMotivo = getFieldError(
    'motivo' as FieldPath<T>
  );

  const errorFechaSolicitudTransferencia = getFieldError(
    'fecha_solicitud_transferencia' as FieldPath<T>
  );


  if (dataTransferenciaInventario)
    return (
      <Grid item container spacing={3}>

        <CustomTextFieldNoForm
          disabled={true}
          label={"Referencia"}
          defaultValue={dataTransferenciaInventario?.numero_referencia || ""}
          size={gridSizeMdLg4}
        />


        <CustomTextFieldNoForm
          disabled={true}
          label={texto.fecha_solicitud_transferencia}
          defaultValue={
            formatDateWithTimeAMPM(
              dataTransferenciaInventario?.fecha_creacion!
            ) || ""
          }
          size={gridSizeMdLg4}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={texto.bodega_origen}
          defaultValue={dataTransferenciaInventario?.bodega_origen_data?.nombre}
          size={gridSizeMdLg4}
        />


        <CustomTextFieldNoForm
          disabled={true}
          label={texto.ubicacion_origen}
          defaultValue={
            dataTransferenciaInventario?.ubicacion_origen_data?.nombre || "PENDIENTE"
          }
          size={gridSizeMdLg4}
        />


        <CustomTextFieldNoForm
          disabled={true}
          label={texto.bodega_destino}
          defaultValue={
            dataTransferenciaInventario?.bodega_destino_data?.nombre || ""
          }
          size={gridSizeMdLg4}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={texto.ubicacion_destino}
          defaultValue={
            dataTransferenciaInventario?.ubicacion_destino_data?.nombre || "PENDIENTE"
          }
          size={gridSizeMdLg4}
        />


        {!isLoadingUT && (
          <CustomAutocomplete<IDtaUnidadTransporte>
            disabled={true}
            required={true}
            size={gridSizeMdLg4}
            label={texto.unidad_transporte}
            name="unidad_transporte"
            options={dataUT?.data.data || []}
            valueKey="chofer_nombre"
            actualValueKey="codigo"
            defaultValue={dataTransferenciaInventario.unidad_transporte || ""}
            isLoadingData={isLoadingUT}
            control={control}
            error={errorUnidadTransporte}
            helperText={errorUnidadTransporte?.message}
          />
        )}

        <CustomTextFieldNoForm
          disabled={true}
          label={"Observación"}
          defaultValue={
            dataTransferenciaInventario?.observaciones?.observaciones_1 || ""
          }
          size={gridSizeMdLg4}
        />

        <CustomTextFieldNoForm
          disabled={true}
          label={"Solicitado por"}
          defaultValue={dataTransferenciaInventario?.solicitado_por || ""}
          size={gridSizeMdLg4}
        />

      </Grid>
    );

  return (
    <Grid item container spacing={3} {...gridSizeMdLg12}>

      <CustomTextField
        disabled={true}
        control={control}
        name="fecha_solicitud_transferencia"
        defaultValue={formatDateWithTimeAMPM(new Date()) || ""}
        size={gridSizeMdLg4}
        label={"Fecha Solicitud"}
        error={errorFechaSolicitudTransferencia}
        helperText={errorFechaSolicitudTransferencia?.message}
      />

      <CustomAutocompleteFetchForm<BODEGAS, any, string>
        control={control}
        size={gridSizeMdLg4}
        name="bodega_origen"
        //isAll
        label={texto.bodega}
        fetchData={fetchAutocompleteBodega}
        getOptionLabel={(opt) => opt.nombre || ''}
        key={'autocomplete-bodega-origen'}
        getOptionKey={(o) => o.codigo!}
        onChangeRawValue={(e) => {
          reset({
            ...form.getValues(),
            ubicacion_origen: null,
            bodega_origen_externa: false,
          });

          if (e) {
            reset({
              ...form.getValues(),
              bodega_origen: e.codigo,
              bodega_origen_externa: e.es_externa
            });
          }
        }}
        loadOptionByValue={async (cod) => {

          const resp = await getBodegas({
            codigo: cod
          });

          return resp.data.data[0] ?? null
        }}
      />


      <CustomAutocompleteFetchForm<Ubicaciones>
        disabled={!bodega_origen}
        control={control}
        size={gridSizeMdLg4}
        name="ubicacion_origen"
        label="Ubicación Origen"
        ///* fetch
        fetchData={fetchAutocompleteUbicacion}
        fetchParams={ubicacionOrigenParams}
        loadOptionByValue={async (codigo) => {
          const res = await getUbicaciones({
            codigo: codigo as string
          });
          return res?.data.data[0] ?? null;
        }}
        getOptionLabel={(opt) => opt.nombre || ''}
        key={'autocomplete-ubicacion-origen'}
        getOptionKey={(o) => o.codigo!}
        onChangeValue={(e) => {
          onChangeDeleteItem && onChangeDeleteItem();

          if (!idsolicitudEgreso) {
            if (e === form.getValues().ubicacion_destino) {
              setAlert(
                true,
                texto.transferencia_misma_bodega,
                AlertSeverityEnum.warning
              );
              reset({ ...form.getValues(), ubicacion_destino: "" });
            }

          }

        }}
      />


      {/* <CustomAutocomplete<BODEGAS>
        size={gridSizeMdLg4}
        label={texto.bodega_destino}
        name="bodega_destino"
        options={bodegas.filter(e => !e.es_transito) || []}
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().bodega_destino || ""}
        isLoadingData={isLoadingbodegas}
        control={control}
        error={errors.bodega_destino}
        helperText={errors.bodega_destino?.message}
        onChangeRawValue={(e) => {
          reset({
            ...form.getValues(),
            ubicacion_destino: null,
            bodega_destino_externa: false
          });
          if (e) {
            reset({
              ...form.getValues(),
              bodega_destino: e.codigo,
              bodega_destino_externa: e.es_externa
            });

          }
        }}
      /> */}

      <CustomAutocompleteFetchForm<BODEGAS, any, string>
        control={control}
        size={gridSizeMdLg4}
        name="bodega_destino"
        disabled={!form.getValues().ubicacion_origen}
        label={texto.bodega_destino}
        fetchParams={bodegaDestinoParams}
        fetchData={fetchAutocompleteBodega}
        getOptionLabel={(opt) => opt.nombre || ''}
        key={'autocomplete-bodega-destino'}
        getOptionKey={(o) => o.codigo!}
        onChangeRawValue={(e) => {
          reset({
            ...form.getValues(),
            ubicacion_destino: null,
            bodega_destino_externa: false
          });
          if (e) {
            reset({
              ...form.getValues(),
              bodega_destino: e.codigo,
              bodega_destino_externa: e.es_externa
            });

          }
        }}
        loadOptionByValue={async (cod) => {
          const resp = await getBodegas({
            codigo: cod
          });

          return resp.data.data[0] ?? null
        }}
      />


      <CustomAutocompleteFetchForm<Ubicaciones, any, string>
        disabled={!bodega_destino}
        size={gridSizeMdLg4}
        control={control}
        name="ubicacion_destino"
        label="Ubicación destino"
        ///* fetch
        fetchParams={ubicacionDestinoParams}
        fetchData={fetchAutocompleteUbicacion}

        getOptionLabel={(opt) => `${opt.nombre}` || ''}
        key={'autocomplete-ubicacion-destino'}
        getOptionKey={(opt) => opt.codigo}
        initialInputValue={form.getValues().ubicacion_destino ?? ''}
        loadOptionByValue={async (codigo) => {
          const res = await getUbicaciones({
            codigo: codigo as string
          });
          return res.data.data[0] ?? null

        }}
        onChangeValue={(e) => {
          if (e == form.getValues().ubicacion_origen) {
            toast.info('No se puede realizar una transferencia entre la misma ubicación.')
            reset({
              ...form.getValues(),
              ubicacion_destino: null
            })
            return
          }

          if (e) {
            reset({
              ...form.getValues(),
              ubicacion_destino: e
            })
          }
        }}

      />


      {/* 
        <CustomAutocompleteFetchForm<Ubicaciones>
          control={control}
          size={gridSizeMdLg4}
          name="ubicacion_destino"
          label="Ubicación Destino"
          //fetchData={fetchAutocompleteUbicacion}
          fetchData={(search, page) => {
            return fetchAutocompleteUbicacion(search, page, {
              bodega: form.getValues().bodega_destino
            })
          }}
          getOptionLabel={(opt) => opt.nombre || ''}
          key={'ubicacion_destino'}
          getOptionKey={(o) => o.id_ubicacion!}
          getValue={(o) => o.codigo!}
          valueKey="codigo"
          loadOptionByValue={async (codigo) => {
            const res = await getUbicaciones({
              codigo: codigo as string
            });
            return res.data.data[0] ?? null
          
          }}
          onChangeValue={(e) => {
            if (e == form.getValues().ubicacion_origen) {
              toast.info('No se puede realizar una transferencia entre la misma ubicación.')
              reset({
                ...form.getValues(),
                ubicacion_destino: null
              })
              return
            }
          }}
        />
      )} */}

      <CustomAutocomplete<IDataMotivo>
        size={gridSizeMdLg4}
        label={"Motivo"}
        name="motivo"
        required={true}
        disabled={disabledForm}
        options={dataMotivo?.data.data || []}
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().motivo || ""}
        isLoadingData={isLoadingMotivo}
        control={control}
        error={errorMotivo}
        helperText={errorMotivo?.message}
      />

      <CustomAutocomplete<IDtaUnidadTransporte>
        required={true}
        disabled={disabledForm}
        size={gridSizeMdLg4}
        label={texto.unidad_transporte}
        name="unidad_transporte"
        options={dataUT?.data.data || []}
        valueKey="chofer_nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().unidad_transporte || ""}
        isLoadingData={isLoadingUT}
        control={control}
        error={errorUnidadTransporte}
        helperText={errorUnidadTransporte?.message}
      />

      {/* <CustomTextField
      control={control}
      name="concepto"
      defaultValue={form.getValues().concepto || ''}
      size={gridSizeMdLg4}
      label={"Concepto"}
      error={errors.concepto}
      helperText={errors.concepto?.message} /> */}

      <CustomTextField
        required={false}
        control={control}
        disabled={disabledForm}
        name="observacion_1"
        defaultValue={form.getValues().observacion_1 || ""}
        size={gridSizeMdLg4}
        label={"Observación"}
        error={errorObservacion1}
        helperText={errorObservacion1?.message}
      />

      <CustomTextField
        control={control}
        required={true}
        disabled={disabledForm}
        name="solicitado_por"
        defaultValue={form.getValues().solicitado_por || ""}
        size={gridSizeMdLg4}
        label={"Solicitado por"}
        error={errorSolicitadoPor}
        helperText={errorSolicitadoPor?.message}
      />

    </Grid>
  );
}
